export default {
  methods: {
    errorModal(message) {
      this.$root.$bvToast.toast(message, {
        title: "Confirmation",
        solid: true,
        autoHideDelay: 3000,
        headerClass: "danger-toast-headerclass",
        bodyClass: "toast-bodyclass",
        toastClass: "",
      });
      this.toasttext = "";
    },
    successModal(message) {
      this.$root.$bvToast.toast(message, {
        title: "Confirmation",
        solid: true,
        autoHideDelay: 5000,
        headerClass: "toast-headerclass",
        bodyClass: "toast-bodyclass",
        toastClass: "",
      });
      this.toasttext = "";
    },
    dynamicToast(type, title, message) {
      const formattedMessage = message.replace(
        /("([^"]*)")/g,
        "<strong>$1</strong>"
      ); // Include double quotes in bold formatting
      let toastHeaderClass = type + "-header-class" + " dynamic-toast-header";

      // Create a virtual DOM element with the formatted message
      const bodyElement = this.$createElement("div", {
        domProps: { innerHTML: formattedMessage },
      });

      this.$root.$bvToast.toast(bodyElement, {
        title: title,
        solid: true,
        autoHideDelay: 5000,
        headerClass: toastHeaderClass,
        bodyClass: "dynamic-toast-body",
        toastClass: "",
      });

      this.toasttext = "";
    },
  },
};
